/**
 * Roles Module - Role Configuration & Permissions
 *
 * Manages RBAC roles and their module-level permissions.
 * Accessed via the Settings navigation group.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const rolesModule: AppModule = {
    id: 'roles',

    navigation: {
        label: 'Roles',
        icon: 'shield',
        path: '/roles',
        order: 4,
        moduleKey: 'settings.users',
        showInSidebar: false, // Accessed via Settings navigation group
        pages: [
            {
                label: 'All Roles',
                path: '/roles',
                icon: 'shield',
            },
            {
                label: 'Add Role',
                path: '/roles/create',
                icon: 'shield-plus',
            },
        ],
    },

    routes,
}

export default rolesModule
